module.exports = __webpack_public_path__ + "static/media/41.e14618bb.jpg";